import { EnhancedRouteProps } from '../../../../routes/Enhanced/Enhanced.route';
import Businesses from './pages/Businesses';
import Business from './pages/Business/pages/Business';
import BusinessEnquire from './pages/Business/pages/BusinessEnquire';

export default [
  {
    path: '',
    element: Businesses,
  },
  {
    path: ':urlFilter',
    element: Businesses,
  },
  {
    path: ':listingCategory/:listingSlug',
    element: Business,
  },
  {
    path: ':listingCategory/:listingSlug/teaser',
    element: BusinessEnquire,
  },
] as Array<EnhancedRouteProps>;
